// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"51843256","977":"084e3513"}[chunkId] + ".chunk.js";
};